import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { 
    BASIC_TOPIC_DETAILS_SECTION_I18N_KEYS as MY_I18N_KEYS, 
    BASIC_TOPIC_DETAILS_SECTION_I18N_PREFIX as MY_I18N_PREFIX 
  } from './constants/i18n/BasicTopicDetailsSectioni18nConstants';
import BasicTopicDetailsForm from '../file-upload/BasicTopicDetailsForm';
import {
    EDIT_TOPIC_TYPE_TAG
  } from '../constants/constants';

class BasicTopicDetailsSection extends Component {
    static propTypes = {
        topicData:                                  PropTypes.object.isRequired,
        isEditingModeForBasicTopicDetailsActive:    PropTypes.bool.isRequired,
        createTopics:                               PropTypes.func.isRequired,
        allCategories:                              PropTypes.array.isRequired,
        resetAddTopicForm:                          PropTypes.bool.isRequired,
        updateTopicsBegin:                          PropTypes.bool.isRequired,
        allTopicNames:                              PropTypes.array.isRequired,
        handleCancelEdit:                           PropTypes.func.isRequired
    };

  constructor(props) {
    super(props);
    this.state = {
        topicData: JSON.parse(JSON.stringify(props.topicData)),
        isEditingModeForBasicTopicDetailsActive: props.isEditingModeForBasicTopicDetailsActive
    };
  }

  getI18nAbsoluteKey(relativeKey) {
    return MY_I18N_PREFIX + "." + relativeKey;
  }

  getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isEditingModeForBasicTopicDetailsActive !== this.state.isEditingModeForBasicTopicDetailsActive) {
        this.setState({
            isEditingModeForBasicTopicDetailsActive: this.props.isEditingModeForBasicTopicDetailsActive
        });
    }
  }

  returnEditBasicTopicDetailsForm() {
    return (
        <BasicTopicDetailsForm
            createTopics={e => this.props.createTopics(e)}
            allCategories={this.props.allCategories}
            resetAddTopicForm={this.props.resetAddTopicForm}
            createOrUpdateTopicsBeginStatus={this.props.updateTopicsBegin}
            allTopicNames={this.props.allTopicNames}
            topicData={this.state.topicData}
            type={EDIT_TOPIC_TYPE_TAG}
            handleCancelEdit={this.props.handleCancelEdit}
        />
    );
  }

  returnUneditableDisplayOfBasicTopicDetails() {
    const { topicData } = this.state;
    return (
        <div className='modal-body data-summary-modal-body'>
            <div className="data-summary-row">
                <div className='col-header'>
                    <span>{this.getI18nText(MY_I18N_KEYS.topic_name)}</span>
                </div>
                <span className="col-cell">{topicData.topicName}</span>
            </div>
            <div className="data-summary-row">
                <div className='col-header'>
                    <span>{this.getI18nText(MY_I18N_KEYS.description)}</span>
                </div>
                <span className="col-cell">{topicData.description || this.getI18nText(MY_I18N_KEYS.no_description_text)}</span>
            </div>
            <div className="data-summary-row">
                <div className='col-header'>
                    <span>{this.getI18nText(MY_I18N_KEYS.categories)}</span>
                </div>
                <div className='uneditable-tags-container'>
                {topicData.categories &&
                    topicData.categories.map((category, _) => (
                    <div className="uneditable-tag-item" key={category}>
                        <span>{category}</span>
                    </div>
                    ))}
                </div>
            </div>
            <div className="data-summary-row">
                <div className='col-header'>
                    <span>{this.getI18nText(MY_I18N_KEYS.email_when_ready)}</span>
                </div>
                <span className="col-cell">{topicData.topicReadyNotificationEmailAddress ? this.getI18nText(MY_I18N_KEYS.yes) : this.getI18nText(MY_I18N_KEYS.no)}</span>
            </div>
        </div>    
    );
  }


  render() {

    const { isEditingModeForBasicTopicDetailsActive } = this.state;
    
    return (
        isEditingModeForBasicTopicDetailsActive ? (
            this.returnEditBasicTopicDetailsForm()
        ) : (
            this.returnUneditableDisplayOfBasicTopicDetails()
        )
    );
  }
}

export default BasicTopicDetailsSection;


// WEBPACK FOOTER //
// ./src/features/topics/components/edit-topic/BasicTopicDetailsSection.js